import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import UseCasesCreateurs from "./pages/UseCasesCreateurs";
import UseCasesConferenciers from "./pages/UseCasesConferenciers";
import UseCasesLocal from "./pages/UseCasesLocal";
import UseCasesCoachs from "./pages/UseCasesCoachs";
import UseCasesAgences from "./pages/UseCasesAgences";
import Pricing from "./pages/Pricing";
import Blog from "./pages/Blog";
import AlternativeEmailMarketing from "./pages/blog/AlternativeEmailMarketing";
import OutilsFidelisationClient from "./pages/blog/OutilsFidelisationClient";
import ProgrammesFideliteEchouent from "./pages/blog/ProgrammesFideliteEchouent";
import NotificationsPushWallet from "./pages/blog/NotificationsPushWallet";
import KpiFideliteClient from "./pages/blog/KpiFideliteClient";
import OutilFidelisationPetitCommerce from "./pages/blog/OutilFidelisationPetitCommerce";
import FidelisationClientGuide from "./pages/blog/FidelisationClientGuide";
import PourquoiClientsPartent from "./pages/blog/PourquoiClientsPartent";
import FidelisationEmotionnelleVsTransactionnelle from "./pages/blog/FidelisationEmotionnelleVsTransactionnelle";
import ClientAmbassadeur from "./pages/blog/ClientAmbassadeur";
import ActionsFidelisationClient from "./pages/blog/ActionsFidelisationClient";
import PushMarketing from "./pages/blog/PushMarketing";
import PushVsPullMarketing from "./pages/blog/PushVsPullMarketing";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Privacy from "./pages/Privacy";
import Affiliation from "./pages/Affiliation";
import AffiliationTerms from "./pages/AffiliationTerms";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/cas-utilisation/createurs-influenceurs" element={<UseCasesCreateurs />} />
            <Route path="/cas-utilisation/conferenciers-evenements" element={<UseCasesConferenciers />} />
            <Route path="/cas-utilisation/commerces-locaux" element={<UseCasesLocal />} />
            <Route path="/cas-utilisation/coachs-communautes" element={<UseCasesCoachs />} />
            <Route path="/cas-utilisation/agences" element={<UseCasesAgences />} />
            <Route path="/tarifs" element={<Pricing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/alternative-email-marketing" element={<AlternativeEmailMarketing />} />
            <Route path="/meilleurs-outils-de-fidelisation-client" element={<OutilsFidelisationClient />} />
            <Route path="/programme-fidelite-ne-fonctionne-pas" element={<ProgrammesFideliteEchouent />} />
            <Route path="/notifications-push-wallet-fidelisation" element={<NotificationsPushWallet />} />
            <Route path="/mesurer-fidelite-client-kpi" element={<KpiFideliteClient />} />
            <Route path="/outil-fidelisation-petit-commerce" element={<OutilFidelisationPetitCommerce />} />
            <Route path="/fidelisation-client-guide" element={<FidelisationClientGuide />} />
            <Route path="/pourquoi-clients-partent" element={<PourquoiClientsPartent />} />
            <Route path="/fidelisation-emotionnelle-vs-transactionnelle" element={<FidelisationEmotionnelleVsTransactionnelle />} />
            <Route path="/client-ambassadeur" element={<ClientAmbassadeur />} />
            <Route path="/7-actions-fidelisation-client" element={<ActionsFidelisationClient />} />
            <Route path="/push-marketing" element={<PushMarketing />} />
            <Route path="/push-vs-pull-marketing" element={<PushVsPullMarketing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/affiliation" element={<Affiliation />} />
            <Route path="/conditions-affiliation" element={<AffiliationTerms />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
